import React from 'react'
import Answers from './answers/Answers'
import OverallFeedbackInput from './answers/OverallFeedbackInput'
import { Flex } from 'antd'

const AllQuestionsContent = ({ submissionId }) => {
    return (
        <Flex vertical gap={8}>
            <Answers submissionId={submissionId} />
            <OverallFeedbackInput submissionId={submissionId} />
        </Flex>
    )
}

export default AllQuestionsContent
